import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, ref } from 'firebase/storage';
import { authEmulatorHost, config, firestoreEmulatorHost } from './config';

const app = initializeApp(config);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const storageRef = ref(storage);

const [host, port] = firestoreEmulatorHost?.split(':') || [];
if (host && port) {
  connectFirestoreEmulator(firestore, host, Number.parseInt(port));
}

if (authEmulatorHost) {
  connectAuthEmulator(getAuth(app), `http://${authEmulatorHost}`);
}
